/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import PlaceMap from './other_components/PlaceMap';
import GreenButton from '../buttons/Green';
import { prepareOptions } from '../../shared_client_utils/formUtils';

const useStyles = makeStyles()(theme => ({
  main: {
    padding: theme.spacing(2, 2, 0, 2),
    backgroundColor: '#ffffff',
    // overflowY: 'auto',
  },
  locationLine: {
    margin: theme.spacing(0, 0, 2, 0),
    alignItems: 'flex-start',
  },
  radioRoot: {
    paddingTop: '3px',
    paddingLeft: 0,
  },
  checkboxLabel: {
    flexDirection: 'column',
  },
  locationName: {},
}));

const Location = (props) => {
  const {
    classes: parentClasses,
    locations,
    currentStep,
    stepsData,
    handleDisplayFlashMessage,
    handleNextStep
  } = props;

  const {classes, cx} = useStyles();
  const currentStepData = currentStep.getData(stepsData);

  const preparedLocations = prepareOptions(locations.byId);

  const [location, setLocation] = useState(() => {
    return preparedLocations.find(({ id }) => id === currentStepData.id) || {};
  });

  const onNextStep = () => {
    if (!location.id) {
      handleDisplayFlashMessage('Select location', 'error');
      return;
    }

    const areValuesChanged = location.id !== currentStepData.id;
    const newStepData = {
      location: {
        ...currentStepData,
        ...location,
      },
    };
    handleNextStep(newStepData, areValuesChanged);
  };

  return (
    <div className={parentClasses.grid}>
      {location?.lat && location?.lng && (
      <PlaceMap
        lat={location.lat}
        lng={location.lng}
        className={parentClasses.mapOrNavigationBox}
        height="300px"
      />
      )}
      <main className={cx(parentClasses.main, classes.main)}>
        <FormControl>
          <RadioGroup
            name="locationId"
            value={location.id}
          >
            {preparedLocations.map(location => (
              <FormControlLabel
                key={location.id}
                name={location.name}
                value={location.id}
                onChange={() => setLocation(location)}
                control={(
                  <Radio
                    color="primary"
                    classes={{
                      root: classes.radioRoot,
                    }}
                    component="div"
                  />
                )}
                label={(
                  <Grid
                    container
                    className={classes.checkboxLabel}
                  >
                    <Grid item className={classes.locationName}>
                      <Typography variant="h6">{location.name}</Typography>
                    </Grid>
                    <Grid item>{location.formattedAddress}</Grid>
                  </Grid>
                )}
                className={classes.locationLine}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </main>

      <footer className={parentClasses.footer}>
        <GreenButton
          stretched
          variant="contained"
          size="large"
          onClick={onNextStep}
          className={parentClasses.mainButton}
        >
          Next
        </GreenButton>
      </footer>
    </div>
  );
};

export default Location;
